document.addEventListener("DOMContentLoaded", function () {
  let searchBox = document.querySelector("#collection-search");
  let productItems = document.querySelectorAll(".product-item");

  searchBox.addEventListener("keyup", function () {
    let query = searchBox.value.toLowerCase();

    productItems.forEach(function (item) {
      let title = item.getAttribute("data-title").toLowerCase();
      if (title.includes(query)) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  });
});
